import { useEffect, useState } from "react";
import api from "./../utils/api";

// วิธีรับเงินของที่พัก อ่านสดจากเซิร์ฟเวอร์
//
// ที่พักที่ถูกเก็บไว้ใน localStorage (`current_hotel`) เป็น snapshot ตั้งแต่ตอนลูกค้าเข้าหน้า
// ที่พักครั้งแรก และไม่เคย refresh อีกเลย ถ้าที่พักสลับมาใช้ payment gateway ระหว่างที่ลูกค้า
// ยังถือค่าเก่า เว็บจะโชว์ flow โอนเงิน+แนบสลิป ทั้งที่ฝั่ง API อ่านค่าจาก DB สดเสมอและจะ
// สร้าง booking แบบ gateway ที่ทิ้งสลิปทิ้ง แล้วถูก cron ยกเลิกใน 15 นาที
// -> ลูกค้าโอนเงินไปจริงแล้ว แต่การจองหายไปเฉยๆ
//
// hook นี้จึงถามเซิร์ฟเวอร์ทุกครั้งที่เข้าหน้าจอง ค่าที่ได้สดชนะ snapshot เสมอ
// ถ้าเรียกไม่สำเร็จก็ตกกลับไปใช้ค่าที่ cache ไว้ (ไม่แย่ไปกว่าเดิม)
const usePaymentFlow = (hotelId, cachedFlow) => {
  const [liveFlow, setLiveFlow] = useState(null);

  useEffect(() => {
    if (!hotelId) return;
    api.request(
      `hotels/${hotelId}/payment-flow`,
      (res, success) => {
        if (success && res?.payment_flow_type) setLiveFlow(res.payment_flow_type);
      },
      {},
      "GET",
      { showError: false }
    );
  }, [hotelId]);

  const flow = liveFlow || cachedFlow || "direct_transfer";

  return {
    flow,
    isGatewayFlow: flow === "gateway",
    // true เมื่อได้ค่าจากเซิร์ฟเวอร์แล้ว (ยังไม่ได้ใช้ที่ไหน แต่ไว้ให้หน้าที่อยากรอค่าก่อนแสดงผล)
    isFlowLoaded: liveFlow !== null,
  };
};

export default usePaymentFlow;
